import { jsx as _jsx } from "react/jsx-runtime";
import { Accordion } from "@components/accordion/Accordion";
import WidgetWrapper from "@components/wrapper/WidgetWrapper";
const AccordionWidget = (props) => {
    const { topMargin, bottomMargin, widgetID, accordionClassName, accordionItems, useRichTextContent = false } = props;
    return (_jsx(WidgetWrapper, { id: widgetID, topMargin: topMargin, bottomMargin: bottomMargin, children: _jsx(Accordion, { accordionClassName: accordionClassName, accordionItems: accordionItems, useRichTextContent: useRichTextContent }) }));
};
export default AccordionWidget;
